import BaseService from './BaseService';

class Auth extends BaseService {
    current() {
        return this.get('/auth/user');
    }

    signin(email, company_id, campaign_id, subject_id, redirect) {
        return this.post('/auth/email/signin', {
            email,
            company_id,
            campaign_id,
            subject_id,
            redirect,
        });
    }

    emailsignin(token) {
        return this.post(`/auth/email/signin/${token}`);
    }

    directSignin(token) {
        return this.post(`/auth/direct/signin/${token}`);
    }

    /**
     * Resend MY sign-in email for old permanent_access_token links.
     * @param {string} token - permanent_access_token
     * @param {object} params - { companyId (o), redirect }
     */
    resendLoginByPermanentToken(token, params = {}) {
        const qs = new URLSearchParams();
        if (params.companyId != null) qs.set('o', params.companyId);
        if (params.redirect) qs.set('redirect', params.redirect);
        const query = qs.toString();
        return this.post(
            `/auth/direct/signin/${encodeURIComponent(token)}/resend${query ? `?${query}` : ''}`
        );
    }

    /**
     * Exchange sign-in link JWT for real session token.
     * Returns real token or throws with response.data: { expired, resent, message }.
     */
    jwtExchange(token) {
        return this.post('/auth/jwt/exchange', { token });
    }

    signOutAudit(companyId, scope = 'my') {
        return this.put(`/auth/log/signout/${companyId}`, { scope });
    }

    switchCompanyAudit(oldCompanyId, newCompanyId, scope = 'my') {
        return this.put(`/auth/log/switch`, {
            newCompanyId,
            oldCompanyId,
            scope,
        });
    }

    checkEmail(email) {
        return this.post('/auth/checkEmail', { email });
    }
}

export default Auth;
